import { create } from 'zustand';
import { resetTablePage } from './use-table-pagination-store';

type ExperienceFilterStore = {
  search: string;
  year: number;
  setSearch: (search: string) => void;
  setYear: (year: number) => void;
  resetExperienceFilters: () => void;
};

const defaultValues = {
  search: '',
  year: new Date().getFullYear(),
};

export const useExperienceFilterStore = create<ExperienceFilterStore>()((set) => ({
  ...defaultValues,
  setSearch: (search) => {
    set({ search });
    resetTablePage();
  },
  setYear: (year) => {
    set({ year });
    resetTablePage();
  },
  resetExperienceFilters: () => {
    set({ ...defaultValues });
    resetTablePage();
  },
}));